<template>
  <div class="borcliste vezne" :style="'height:'+Height+'px'">
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      v-if="!SeciliBina"
      :closable="false"
      title="Borçlu listesi için Bina seçiniz"
      type="error">
    </el-alert>
    <el-input
      v-if="SeciliBina && Liste"
      placeholder="Arama"
      prefix-icon="el-icon-search"
      v-model="search">
    </el-input>
    <ul v-if="SeciliBina && Liste"  :style="'height:'+(Height-75)+'px' ">
      <router-link
        v-for="Borc in Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()))"
        :to="'/vezne/tahsilat/'+Borc.Kisi_id" tag="li" active-class="Aktif">
        <div class="kisiBilgi">
          <span class="borcAd">{{ Borc.AdSoyad }}</span>
          <span class="borcBina">{{ Borc.Kat }} Kat {{ Borc.kNo }} No</span>
        </div>
        <div class="borcBilgi">
          <div class="text-success"><b>Anapara</b> {{ Borc.Tutar }}</div>
          <div class="text-danger"><b>Zam</b> {{ Borc.Zam }}</div>
          <div class="text-primary"><b>Ödenecek</b> {{ Borc.Odenecek }}</div>
        </div>
      </router-link>
      <el-alert
        :closable="false"
        v-if="!Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()))[0]"
        title="Uygun Kayıt Bulunamadı"
        type="error">
      </el-alert>
    </ul>
  </div>
</template>

<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Yenile"],
  data() {
    return {
      Kisi_id: null,
      Height: window.innerHeight - 145,
      SayfaAdi: 'Tahsilat Listesi',
      SeciliBina: null,
      Liste: null,
      search: null,
      lo: true
    }
  },
  methods: {

    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'vezne/kisiler/' + this.SeciliBina})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
            this.lo = false
          }
        });
    }
  },
  created() {
    if (this.$store.getters.BinaBilgi) {
      this.SeciliBina = this.$store.getters.BinaBilgi.id;
    }
    this.SayfaYukle();
  },
  computed: {
    rSAyfaYukle() {
      return this.Yenile
    },
  },
  watch: {
    rSAyfaYukle() {
      if (this.Yenile) this.SayfaYukle();
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/VezneListe.vue